import React, { Component } from 'react'
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { LocationActions } from '../../actions';
import TitleBar from '../../components/TitleBar';
import SubnavBar from '../../components/SubnavBar';
import LocationForm from '../../components/Locations/Edit';

export class EditLocation extends Component {
  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);

    this.state = {
      error: false,
      initialValues: null,
    }
  }

  componentWillMount() {
    const { locations } = this.props;
    const { locationId } = this.props.params;
    if (locationId) {
      const data = _.find(locations, { id: locationId });
      this.setState({
        initialValues: data,
      })
    }
  }

  gotoLocations = () => {
    browserHistory.push('/locations');
  }
  
  saveLocation = (values) => {
    const { auth, dispatch } = this.props;
    const profile = auth.auth.getProfile();
    const address = `${values.street} ${(values.street2) ? values.street2 : ''}, ${values.city}, ${values.state} ${values.zip}`;

    const location = {
      name: values.name,
      address,
      customerId: profile.companyId,
    };
    dispatch(LocationActions.saveLocation(location)).then((response) => {
      browserHistory.push('/locations');
    }).catch((e) => {
      this.setState({
        error: true
      })
    });
  }

  handleClose() {
    this.setState({
      error: false
    });
  }

  render() {
    const actions = [
      <FlatButton label="Ok" primary onTouchTap={this.handleClose} />
    ];
    return (
      <div className="row">
        <div className="col s12">
          <SubnavBar back={this.gotoLocations} />
          <TitleBar title="Location" />
          <div className="row">
            <div className="col s12">
              <LocationForm onSubmit={this.saveLocation} initialValues={this.state.initialValues} />
              <Dialog
                actions={actions}
                modal={false}
                open={this.state.error}
                onRequestClose={this.handleClose}
              >
                There was an error with the address provided. Please update and try again.
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { auth, locations } = state;
  return {
    auth,
    locations
  }
}

export default connect(mapStateToProps)(EditLocation);


// WEBPACK FOOTER //
// ./src/containers/Locations/Edit.js